export function Footer() {
  return (
    <footer className="border-t border-[#27272A] mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-500">
        <div>
          &copy; {new Date().getFullYear()} Webtu &middot; Made for Indian MSMEs
        </div>
        <div className="flex items-center gap-4">
          <a
            href="https://webtu.in"
            data-testid="footer-home-link"
            className="hover:text-[#E5C378] transition-colors"
          >
            webtu.in
          </a>
          <a
            href="https://webtu.in/pricing"
            data-testid="footer-pricing-link"
            className="hover:text-[#E5C378] transition-colors"
          >
            Pricing
          </a>
          <a
            href="https://webtu.in/contact"
            data-testid="footer-contact-link"
            className="hover:text-[#E5C378] transition-colors"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
